import { Button, ButtonProps } from '@mm/components';
import { ButtonColor as StringButtonColor } from '@mm/constants/button-color';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { nextBillingTypeForFeatureSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { PlanBadge } from '../../components/ProBadge';
import './PrimaryButton.pcss';

export const enum ButtonColor {
  blue = 'blue',
  secondaryBlue = 'secondary-blue',
  red = 'red',
  invertedRed = 'inverted-red',
  green = 'green',
  greenGradient = 'green-gradient',
  transparent = 'transparent',
  gray = 'gray',
}

type Props = Omit<ButtonProps, 'color'> & {
  color?: ButtonColor | StringButtonColor;
  requiredFeature?: SubscriptionFeatureFlag;
};

const PrimaryButtonBase = (props: Props) => {
  const { children, requiredFeature, ...restProps } = props;

  const billingType = useSelector((state: StoreState) =>
    nextBillingTypeForFeatureSelector(state, requiredFeature),
  );

  return (
    <Button {...restProps}>
      {children}
      {billingType && (
        <PlanBadge
          className="primary-button__plan-badge"
          billingType={billingType}
          size={10}
        />
      )}
    </Button>
  );
};

export const PrimaryButton = (props: Props & { className?: string }) => {
  const { css: propsCss, className } = props;
  const css = {
    ...propsCss,
    container: classnames(className, propsCss?.container),
  };

  return <PrimaryButtonBase {...props} css={css} />;
};
